<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select-multiple
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="percentuais"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  name: "c-protocolo-periodo-solicitado",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: Array,
    required: Boolean
  },
  data() {
    return {
      percentuais: [
        { value: "Abril", text: "Abril" },
        { value: "Maio", text: "Maio" },
        { value: "Junho", text: "Junho" }
      ]
    };
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/PeriodoSolicitado.vue